/*
(function () {
  const stickyBanner = document.querySelector('.sticky_add');
  if (stickyBanner) {
    const stickyBuy = stickyBanner.querySelector('#ProductSubmitButton');
    stickyBuy.setAttribute("disabled", '');
    const stickyBannerVariantSelectors = stickyBanner.querySelector('.product__info-container');
    const sizeFieldset = document.querySelector('#size-variant');
    const sizeChartOpener = stickyBanner.querySelector('.size-chart__opener');
    const config = { childList: true, subtree: true };

    if (!sizeFieldset) return;

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          sizeChartOpener.addEventListener('click', (event) => {
            let sizeChartElement = mutation.addedNodes[0].querySelector('.ks-chart-modal-link');
            const clickEvent = new Event('click');
            if (sizeChartElement) sizeChartElement.dispatchEvent(clickEvent);
          });
          observer.disconnect();
        }
      }
    };

    stickyBuy.addEventListener('click', (e) => {
      e.preventDefault()
      document.querySelector('.product #ProductSubmitButton').click();
    });

    window.addEventListener('click', (event) => {
      if (!stickyBanner.contains(event.target) && !sizeFieldset.contains(event.target) && stickyBannerVariantSelectors.classList.contains('show')) {
        stickyBannerVariantSelectors.classList.remove('show');
      } else if (event.target.querySelector('[name="add"][disabled]')) {
        stickyBannerVariantSelectors.classList.add('show');
      }
    });

    const observer = new MutationObserver(callback);
    observer.observe(sizeFieldset, config);
  }
})();
*/

(function () {
  const stickyBanner = document.querySelector('.sticky_add');
  if (stickyBanner) {
    // Toggle sticky banner visibility based on the main (static) CTA visibility (mobile only)
    (function initStickyVisibilityToggle() {
      const mq = window.matchMedia('(max-width: 749px)');

      const setup = () => {
        const ctas = Array.from(document.querySelectorAll('.product__cta'));
        const mainCta = ctas.find((el) => !stickyBanner.contains(el));
        if (!mainCta) return;

        const initialDisplay = stickyBanner.style.display;
        const setHidden = (hidden) => {
          stickyBanner.style.display = hidden ? 'none' : (initialDisplay || '');
        };

        const io = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            setHidden(!!entry && entry.isIntersecting);
          },
          { threshold: 0.01 }
        );

        io.observe(mainCta);
      };

      if (mq.matches) setup();

      const onChange = (e) => {
        if (e.matches) {
          setup();
        } else {
          stickyBanner.style.display = 'none';
        }
      };

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onChange);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(onChange);
      }
    })();

    const stickyBuy = stickyBanner.querySelector('#ProductSubmitButton');
    stickyBuy.setAttribute('disabled', '');
    const stickyBannerVariantSelectors = stickyBanner.querySelector('.product__info-container');
    const sizeFieldset = document.querySelector('#size-variant');
    const sizeChartOpener = stickyBanner.querySelector('.size-chart__opener');
    const config = { childList: true, subtree: true };

    if (!sizeFieldset) return;

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          sizeChartOpener.addEventListener('click', (event) => {
            let sizeChartElement = mutation.addedNodes[0].querySelector('.ks-chart-modal-link');
            const clickEvent = new Event('click');

            if (sizeChartElement && clickEvent) {
              sizeChartElement.dispatchEvent(clickEvent);
            }
          });

          mutation.addedNodes.forEach((node) => {
            if (
              node.classList &&
              node.classList.contains('js-variant-pick') &&
              !node.classList.contains('disabled')
            ) {
              stickyBuy.removeAttribute('disabled');
            } else if (
              node.classList &&
              node.classList.contains('js-variant-pick') &&
              node.classList.contains('disabled')
            ) {
              stickyBuy.setAttribute('disabled', '');
            }
          });
        }
      }
    };

    stickyBuy.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.product #ProductSubmitButton').click();
    });

    window.addEventListener('click', (event) => {
      if (
        !stickyBanner.contains(event.target) &&
        !sizeFieldset.contains(event.target) &&
        stickyBannerVariantSelectors.classList.contains('show')
      ) {
        stickyBannerVariantSelectors.classList.remove('show');
      } else if (event.target.querySelector('[name="add"][disabled]')) {
        stickyBannerVariantSelectors.classList.add('show');
      }
    });

    const observer = new MutationObserver(callback);
    observer.observe(sizeFieldset, config);
  }
})();